/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Dashboard_Keep_Current_PlanInputs */



/**
* | output |
* | --- |
* | "Keep current plan" |
*
* @param {Sub_Dashboard_Keep_Current_PlanInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_dashboard_keep_current_plan = /** @type {((inputs?: Sub_Dashboard_Keep_Current_PlanInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Dashboard_Keep_Current_PlanInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Aktuellen Tarif beibehalten")
	return /** @type {LocalizedString} */ ("Keep current plan")
});